import { replace } from "@/services/useful";


    // LOCALHOST
        export function LOCALHOST()
        {
            if(window.location.href.split('http://localhost:')[1]){
                return 1;
            }
            return 0;
        }
    // LOCALHOST







    // APP
        export function APP()
        {
            return ($_APP!=undefined ? $_APP : 0);
        }
    // APP



    // DIR
        export function DIR() // HTTPS:DOMINIO/DIR
        {
            return `${window.location.origin}${$_GLOBAL.DIR}`
        }
    // DIR



    // DIR__
        export function DIR__() // /DIR
        {
            return `${$_GLOBAL.DIR}/`;
        }
    // DIR__



    // DIR_P
        export function DIR_P() // PUBLIC_HTML
        {
            return `${$_GLOBAL.DIR_API}/../..`;
        }
    // DIR_P



    // DIR_API
        export function DIR_API() // PUBLIC_HTML/PHP/API
        {
            return $_GLOBAL.DIR_API;
        }
    // DIR_API



    // DIR_PHP
        export function DIR_PHP() // PUBLIC_HTML/PHP
        {
            return `${$_GLOBAL.DIR_API}/..`;
        }
    // DIR_PHP



    // DIR_APP
    export function DIR_APP() // .APP
    {
        return `${$_GLOBAL.DIR_API}/../../../.app`;
    }
    // DIR_APP

    

    // DIR_DATA
        export function DIR_DATA() // .DATA
        {
            return `${$_GLOBAL.DIR_API}/../../../.data`;
        }
    // DIR_DATA
